/**
 * 网络请求配置
 */
import axios from "axios"
import { notification } from 'antd'

let serverURL = process.env.REACT_APP_SERVER_URL
let oldConsoleUrl = process.env.REACT_APP_OLD_CONSOLE_URL


axios.defaults.timeout = 100000
axios.defaults.baseURL = serverURL

/**
 * http request 拦截器
 */
axios.interceptors.request.use(
    (config) => {
        config.data = JSON.stringify(config.data)
        config.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + document.cookie,
            // "withCredentials": "include",
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)


/**
 * http response 拦截器
 */
axios.interceptors.response.use(
    (response) => {
        // console.log('http response 拦截器',response)
        return response
    },
    (error) => {
        console.log("请求出错：", error)
        // 登录失效、重新登录
        if (error.response.status === 401) {
            console.log("登录失效、重新登录!")
            window.location.href = oldConsoleUrl + "/site/login"

        } else if (error.response.status === 403) {
            let returnData = error.response.data
            console.log("Http.js", returnData)
            // 用户没申请企业
            if (returnData.code === 1001) {
                window.location.href = oldConsoleUrl + "/user/corporation/index"
            } else if (returnData.code === 1004) {
                notification.error({
                    message: 'Error',
                    description: returnData.msg,
                })
            } else {
                notification.error({
                    message: 'Error',
                    description: returnData.msg,
                })
            }

        }

    }
)


/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */
export function get (url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params,
        }).then((response) => {
            landing(url, params, response.data)
            resolve(response.data)

        }).catch((error) => {
            reject(error)
        })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post (url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data).then(
            (response) => {
                //关闭进度条
                resolve(response.data)
            },
            (err) => {
                reject(err)
            }
        )
    })
}


/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data).then(
            (response) => {
                resolve(response.data)
            },
            (err) => {
                msag(err)
                reject(err)
            }
        )
    })
}


/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put (url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data).then(
            (response) => {
                resolve(response.data)
            },
            (err) => {
                msag(err)
                reject(err)
            }
        )
    })
}


/**
 * 封装delete请求
 * @param url
 * @param params
 * @returns {Promise}
 */
export function deleteAxios (url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            params: params,
        }).then((response) => {
            landing(url, params, response.data)
            resolve(response.data)

        }).catch((error) => {
            reject(error)
        })
    })
}

//失败提示
function msag (err) {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                alert(err.response.data.error.details)
                break
            case 401:
                alert("未授权，请登录")
                break

            case 403:
                alert("拒绝访问")
                break

            case 404:
                alert("请求地址出错")
                break

            case 408:
                alert("请求超时")
                break

            case 500:
                alert("服务器内部错误")
                break

            case 501:
                alert("服务未实现")
                break

            case 502:
                alert("网关错误")
                break

            case 503:
                alert("服务不可用")
                break

            case 504:
                alert("网关超时")
                break

            case 505:
                alert("HTTP版本不受支持")
                break
            default:
        }
    }
}

/**
 * 查看返回的数据
 * @param url
 * @param params
 * @param data
 */
function landing (url, params, data) {
    if (data.code === -1) {

    }
}


//统一接口处理，返回数据
const Http = function (fetch, url, param) {
    return new Promise((resolve, reject) => {
        switch (fetch) {
            case "get":
                get(url, param)
                    .then(function (response) {
                        resolve(response)
                    })
                    .catch(function (error) {
                        console.log("get request failed.", error)
                        reject(error)
                    })
                break
            case "post":
                post(url, param)
                    .then(function (response) {
                        resolve(response)
                    })
                    .catch(function (error) {
                        console.log("post request failed.", error)
                        reject(error)
                    })
                break
            case "patch":
                patch(url, param)
                    .then(function (response) {
                        resolve(response)
                    })
                    .catch(function (error) {
                        console.log("patch request failed.", error)
                        reject(error)
                    })
                break
            case "put":
                put(url, param)
                    .then(function (response) {
                        resolve(response)
                    })
                    .catch(function (error) {
                        console.log("put request failed.", error)
                        reject(error)
                    })
                break
            case "delete":
                deleteAxios(url, param)
                    .then(function (response) {
                        resolve(response)
                    })
                    .catch(function (error) {
                        console.log("delete request failed.", error)
                        reject(error)
                    })
                break
            default:
                break
        }
    })
}

export default Http